import React from 'react';
import { isValidDatePickerDate } from '../../helpers/AppHelpers';
import { YEARS_ONLY_FORMAT } from '../../constants/exportDateFormatTypes';

const getValidDateAppearance = (start, end, dateFormat) => {
  const formatDate = (date) => {
    if (!isValidDatePickerDate(date)) return date;
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    if (dateFormat === YEARS_ONLY_FORMAT) {
      return `${year}`;
    }
    return `${month}.${year}`;
  };

  const startDate = formatDate(start);
  const endDate = end ? formatDate(end) : 'till now';
  return (
    start && (
      <p className="text-xs font-medium pb-1">
        {startDate} - {endDate}
      </p>
    )
  );
};

export default getValidDateAppearance;
